import { render, staticRenderFns } from "./FrameVideo.vue?vue&type=template&id=11590cb0&scoped=true&"
import script from "./FrameVideo.vue?vue&type=script&lang=js&"
export * from "./FrameVideo.vue?vue&type=script&lang=js&"
import style0 from "./FrameVideo.vue?vue&type=style&index=0&id=11590cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11590cb0",
  null
  
)

export default component.exports